module.exports = [{"source":"/privacy-policy","destination":"/privacy","permanent":true},{"source":"/past-projects","destination":"/","permanent":true}];